// extracted by mini-css-extract-plugin
export default {"logo":"footer_logo__IRoNB"};